import { get, robotCmd } from '../api/client';
import { dockErrorText } from './chargerState';
import { t } from '../i18n';
import { navigateTo } from './nav';
import type { Lang, MapSummary } from '../api/types';
import { toast, toastErr } from '../components/toast';
import { useLive } from '../live/store';

export const LANGS: { id: Lang; label: string }[] = [
  { id: 'uz', label: "O'zbek" },
  { id: 'ru', label: 'Русский' },
  { id: 'en', label: 'English' },
];

/** Open the robot's current map in Set-pose mode (after NOT_LOCATED). */
export async function openSetPose(serial: string) {
  const mapName = useLive.getState().robots[serial]?.status?.currentMap;
  let id: string | undefined;
  if (mapName) {
    try {
      id = (await get<MapSummary[]>('/api/maps')).find((m) => m.name === mapName)?.id;
    } catch {
      /* fall through */
    }
  }
  if (!id) {
    toast(mapName ? t('mapRobots.mapNotOnServer', { name: mapName }) : t('mapRobots.noMapLoaded'), 'err');
    navigateTo('/maps');
    return;
  }
  navigateTo(`/maps/${id}?setpose=${encodeURIComponent(serial)}`);
}

/** Send a command to one robot, logging to its event log; returns data or null. */
export async function sendCmd(serial: string, name: string, args: Record<string, unknown> = {}, label?: string) {
  const live = useLive.getState();
  live.addLog(serial, 'cmd', `→ ${name}`, label ?? (Object.keys(args).length ? JSON.stringify(args) : ''));
  try {
    const r = await robotCmd(serial, name, args);
    if (r.ok) {
      live.addLog(serial, 'ok', `✓ ${name}`, r.data && Object.keys(r.data).length ? JSON.stringify(r.data) : '');
      return r.data;
    }
    live.addLog(serial, 'err', `✗ ${name}`, `${r.error.code}: ${r.error.message}`);
    const notLocated = r.error.code === 'NOT_LOCATED' && (name === 'navigate' || name === 'goToPoint');
    const dockText = dockErrorText(r.error);
    if (dockText) {
      toast(`${live.robots[serial]?.name ?? serial}: ${dockText}`, 'err');
      return null;
    }
    if (r.error.code === 'HAND_PUSH') {
      toast(`${live.robots[serial]?.name ?? serial}: ${t('hand.blocked')}`, 'err');
      return null;
    }
    toast(`${live.robots[serial]?.name ?? serial}: ${name} — ${r.error.code}: ${r.error.message}`, 'err', notLocated ? { label: t('mapRobots.setPose'), onClick: () => void openSetPose(serial) } : undefined);
  } catch (e) {
    live.addLog(serial, 'err', `✗ ${name}`, (e as Error).message);
    toastErr(e, name);
  }
  return null;
}

